import { AppsyncClient } from '@myap/ui-library/esm/appsync'

export const getAppsyncClient = () => AppsyncClient(Config.DIGITALEXAMS_APPSYNC_URL)
